import { CdkStepperModule } from '@angular/cdk/stepper';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatStepperModule } from '@angular/material/stepper';
import { AbcUiComponentsModule } from '@barthauer/abc/ui-components';
import { DxProgressBarModule } from 'devextreme-angular';
import { ContentPageWrapperComponent } from './pages/content-page-wrapper/content-page-wrapper.component';
import { DataService } from 'libs/abc/core/data/src/lib/data.service';
import { WizardExportComponent } from './wizard-export.component';
import { WizardExportService } from './wizard-export.service';

@NgModule({
  declarations: [WizardExportComponent, ContentPageWrapperComponent],
  exports: [WizardExportComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatStepperModule,
    MatFormFieldModule,
    AbcUiComponentsModule,
    MatMenuModule,
    MatIconModule,
    DxProgressBarModule,
    CdkStepperModule,
  ],
  providers: [WizardExportService, DataService, provideHttpClient(withInterceptorsFromDi())],
})
export class WizardExportModule {}
